/*
 * Kivora gallery grouping by colour (snippets/kv-media-group.liquid, main-product setting
 * "Group photos by colour"). Hides gallery slides, thumbnails and lightbox items whose alt text names a
 * different value of the grouping option than the selected variant's. Photos that name no value, or
 * several, always show. Re-applies after Dawn swaps the gallery on variant change.
 */
(() => {
  const esc = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const setup = (node) => {
    if (node.dataset.kvReady) return;
    node.dataset.kvReady = 'true';
    let config;
    try {
      config = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }
    const sectionId = node.dataset.kvMediaGroup;
    const root = document.getElementById(`MainProduct-${sectionId}`);
    if (!root || !Array.isArray(config.values)) return;

    const values = config.values.map((value) => String(value).toLowerCase());
    const groupOf = {};
    Object.keys(config.media || {}).forEach((id) => {
      const alt = String(config.media[id] || '').toLowerCase();
      const hits = values.filter((value) => new RegExp(`(^|[^a-z0-9])${esc(value)}([^a-z0-9]|$)`).test(alt));
      groupOf[id] = hits.length === 1 ? hits[0] : null;
    });

    let selected = String(config.selected || '').toLowerCase();
    let lastSignature = '';

    const mediaIdOf = (element) => {
      const raw = element.dataset.mediaId || element.dataset.target || '';
      return raw.split('-').pop();
    };

    const signature = () =>
      `${selected}|${Array.from(root.querySelectorAll('[data-media-id], [data-target]'), mediaIdOf).join(',')}`;

    // Only touches the DOM when the selected value or the set of gallery items changed, so the slider
    // refresh below can never feed back into the observer.
    const apply = () => {
      const current = signature();
      if (current === lastSignature) return;
      lastSignature = current;
      let changed = false;
      root.querySelectorAll('[data-media-id], [data-target]').forEach((element) => {
        const group = groupOf[mediaIdOf(element)];
        const off = Boolean(group && group !== selected);
        if (element.classList.contains('kv-media-off') !== off) {
          element.classList.toggle('kv-media-off', off);
          changed = true;
        }
      });
      const initial = document.querySelector(`style[data-kv-media-group-initial="${sectionId}"]`);
      if (initial) initial.remove();
      if (changed) {
        root.querySelectorAll('slider-component').forEach((slider) => {
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
      }
    };

    if (!document.getElementById('kv-media-group-style')) {
      const style = document.createElement('style');
      style.id = 'kv-media-group-style';
      style.textContent = '.kv-media-off{display:none !important;}';
      document.head.appendChild(style);
    }

    apply();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || data.sectionId !== sectionId || !data.variant || !Array.isArray(data.variant.options)) return;
        selected = String(data.variant.options[config.index] || '').toLowerCase();
        window.setTimeout(apply, 0);
      });
    }

    const gallery = root.querySelector('media-gallery');
    if (gallery && 'MutationObserver' in window) {
      const isMediaItem = (node) => node.nodeType === 1 && node.matches('[data-media-id], [data-target]');
      new MutationObserver((records) => {
        const touched = records.some((record) =>
          Array.from(record.addedNodes).some(isMediaItem) || Array.from(record.removedNodes).some(isMediaItem)
        );
        if (touched) apply();
      }).observe(gallery, { childList: true, subtree: true });
    }
  };

  const init = () => document.querySelectorAll('script[data-kv-media-group]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
